import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertToHtml',
    standalone: false
})
export class ConvertToHtmlPipe implements PipeTransform {

    transform(value: string): string {
        const replacedText = value
            .replace(/&nbsp;/g, ' ');

        return replacedText;
    }
}
